import { useEffect, useRef } from "react";

export const useNotifications = (success, error) => {
  const notificationSystem = useRef();

  useEffect(() => {
    const notificationSystemInstance = notificationSystem.current;
    if (notificationSystemInstance) {
      if (success?.message) {
        notificationSystemInstance.addNotification({
          message: success.message,
          level: "info",
          position: "tc",
        });
      }
      if (error?.message) {
        notificationSystemInstance.addNotification({
          message: error.message,
          level: "error",
          position: "tc",
        });
      }
    }
  }, [success.message, error.message]);

  return notificationSystem;
};
